/** The three glyphs the map draws. No emoji, no illustrations. */

export function TickIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 22 22" fill="none" strokeWidth="3"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4.5 11.5l4.5 4.5 8.5-9" />
    </svg>
  );
}

export function BoltIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M13 3L5 13.5h5.5L11 21l8-10.5h-5.5L13 3z" />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg width="15" height="17" viewBox="0 0 15 17" fill="none" stroke="currentColor"
      strokeWidth="1.8" aria-hidden="true">
      <rect x="1.5" y="7" width="12" height="8.5" rx="2.4" />
      <path d="M4.5 7V5a3 3 0 0 1 6 0v2" />
    </svg>
  );
}
